<template>
    <ejs-tooltip
        ref="tooltip"
        :opensOn="opensOn"
        :cssClass="tooltipClasses"
        :content="tooltipContent"
        :position="position"
        :width="width"
        :beforeClose="tooltipBeforeClose"
        :beforeOpen="tooltipBeforeOpen"
        :afterOpen="tooltipAfterOpen"
        :id="uniqueToolTipId"
        :created="onTooltipCreated"
    ><span v-if="label || showWithEmptyLabel" class="tooltip-label" :class="tooltipLabelClasses" v-html="label"></span><slot></slot>
    </ejs-tooltip>
</template>
<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";

const SamTooltipComponent = {
    name: "samTooltip",
    dataTestIds: [],
    props: {
        teleportId: {
            type: String,
            default: false
        },
        content: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        opensOn: {
            type: String,
            default: 'Click'
        },
        labelClasses: {
            type: String,
            default: 'help-tooltip'
        },
        cssClass: {
            type: String,
            default: ''
        },
        position: {
            type: String,
            default: 'TopCenter'
        },
        width: {
            type: String,
            default: ''
        },
        showWithEmptyLabel: {
            type: Boolean,
            default: false
        },
        tooltipClosed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            uniqueToolTipId: 'tooltip_' + library.getUniqueID(),
            tooltipCreated: false,
            closeTooltip: false
        };
    },
    computed: {
        tooltipContent() {
            if (this.content) return this.content;
            let content = '';
            if (this.tooltipCreated) {
                if (this.teleportId) content = `<div id="${this.teleportId}"></div>`;
                else {
                    // TODO possibly replace this and just use Teleport
                    let contentElem = document.querySelector('#' + this.uniqueToolTipId + ' .tooltip-content-slot');
                    content = contentElem && contentElem.innerHTML;
                    // Clear the HTML of the "slot" element
                    if (content) contentElem.innerHTML = "";
                }
            }
            return content;
        },
        tooltipId() {
            return this.id + '_tooltip';
        },
        tooltipPosition() {
            return 'TopCenter';
        },
        tooltipLabelClasses() {
            let output = this.tooltipId;
            if (this.labelClasses) output += ' ' + this.labelClasses;
            return output;
        },
        tooltipClasses() {
            let output = this.tooltipId + ' ' + this.tooltipPosition;
            if (this.cssClass) output += ' ' + this.cssClass;
            return output;
        },
    },
    watch: {
        tooltipClosed(closed) {
            if (closed) {
                if (this.closeTooltip) document.removeEventListener("click", this.closeTooltip);
                this.$refs.tooltip.close();
            }
        }
    },
    methods: {
        tooltipBeforeClose() {
            this.$emit('update:beforeClose', true);
        },
        onTooltipCreated() {
            this.tooltipCreated = true;
        },
        tooltipBeforeOpen() {
            if (this.closeTooltip) document.removeEventListener("click", this.closeTooltip);
        },
        tooltipAfterOpen() {
            this.$emit('update:afterOpen', true);
            if (!this.closeTooltip) {
                this.closeTooltip = (args) => {
                    // Check for clicking component or other sub-element in tooltip
                    let tooltipParent = args.target.closest('.' + this.tooltipId);
                    let tooltipTeleportElem = args.target.closest('#' + this.teleportId);
                    if (!tooltipParent) { // Check for dropdown option targeted (options pop-ups are appended to the body)
                        let ddOptionsPopupElId = args.target.parentNode.id
                            && args.target.parentNode.id.replace('_options', '');
                        let ddControlElement = document.getElementById(ddOptionsPopupElId);
                        tooltipParent = ddControlElement && ddControlElement.closest('.' + this.tooltipId);
                    }
                    if (
                        !args.target.classList.contains(this.tooltipId)
                        && (
                            (!tooltipParent && !tooltipTeleportElem)
                            || (args.target && (args.target).id === "btnclose")
                        )
                    ) {
                        document.removeEventListener("click", this.closeTooltip);
                        this.$refs.tooltip.close();
                    }
                };
            }
            document.addEventListener("click", this.closeTooltip);
        }
    },
    beforeUnmount() {
        if (this.closeTooltip) document.removeEventListener("click", this.closeTooltip);
    },
    components: {
        'ejs-tooltip': defineAsyncComponent(() => import('@common/syncfusion/tooltip'))
    }
};
export default SamTooltipComponent;
</script>

<style scoped>
.e-icons.e-info:before {
    content: '\e607' !important;
}
.tooltip-label {
    font-size: 16px;
    position: relative;
    color: #5a5a62;
    cursor: pointer;
}
.help-tooltip {
    opacity: 0.25;
}
.help-tooltip:hover {
    opacity: 1
}
.e-control.e-tooltip {
    display: inline-block;
}
.e-icons.e-info:before {
    content: '\e607' !important;
}
.help-tooltip {
    font-size: 16px;
    position: relative;
    top: 5px;
    color: #5a5a62;
    cursor: pointer;
    opacity: 0.25;
}
.help-tooltip:hover {
    opacity: 1
}
:deep(.tooltip-content-slot) {
    display: none;
}
</style>
